import { render, staticRenderFns } from "./quotaLimit.vue?vue&type=template&id=21efc9a9&scoped=true"
import script from "./quotaLimit.vue?vue&type=script&lang=js"
export * from "./quotaLimit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21efc9a9",
  null
  
)

export default component.exports